<template>
    <a-card :bordered="false">
      <!-- table区域-begin -->
      <a-button type="primary" icon="download" @click="handleExportXls('考场报告')">导出详细报告</a-button>
      <a-divider type="vertical"></a-divider>
      <a-button @click="loadData" icon="reload">刷新</a-button>
      <a-divider></a-divider>
      <div>
        <a-table
          ref="table"
          size="middle"
          :scroll="{ x: true }"
          bordered
          rowKey="id"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="ipagination"
          :loading="loading"
          class="j-table-force-nowrap"
          @change="handleTableChange"
        >
        </a-table>
      </div>
    </a-card>
  </template>
  
  <script>
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { getAction, postAction } from '@/api/manage'
  export default {
    name: 'DeptPaperReport',
    mixins: [JeecgListMixin, mixinDevice],
    data() {
      return {
        description: '考场报告',
        ipagination:{
          pageSize: 20
        },
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            align: 'center',
            customRender: function (t, r, index) {
              return parseInt(index) + 1
            },
          },
          {
            title: '账号',
            align: 'center',
            dataIndex: 'username',
          },
          {
            title: '姓名',
            align: 'center',
            dataIndex: 'realname',
          },
          {
            title: '绑定手机号',
            align: 'center',
            dataIndex: 'phone',
          },
          {
            title: '状态',
            align: 'center',
            dataIndex: 'userPaperStatus_dictText',
            customRender: function (text) {
              if(text)
              return text
              else
              return '未到场'
            },
          },
          {
            title: '开考时间',
            align: 'center',
            dataIndex: 'createTime',
          },
          {
            title: '交卷时间',
            align: 'center',
            dataIndex: 'submitTime',
          },
          {
            title: '得分',
            align: 'center',
            dataIndex: 'gotScore',
          },
        ],
        url: {
          list: '/teaching/teachingPaperDept/report',
          exportXlsUrl: '/teaching/teachingPaperDept/exportReport',
        },
        dictOptions: {},
        disableMixinCreated: true,
      }
    },
    created() {},
    methods:{
      open(id){
          this.queryParam.paperDeptId = id
          this.loadData(1)
      }
    }
  }
  </script>
  
  <style>
  </style>